/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ValidationMessage } from "./ValidationMessage";
import { CellValueUnion } from "./CellValueUnion";
export const CellValue = core.serialization.object({
    valid: core.serialization.boolean().optional(),
    messages: core.serialization.list(ValidationMessage).optional(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    value: CellValueUnion.optional(),
    layer: core.serialization.string().optional(),
    updatedAt: core.serialization.date().optional(),
});
